import {QuantityUnit} from "@/model/QuantityUnit";
import {Currency} from "@/model/Currency";

export class PricePerUom {
    value: number;
    currency: Currency;
    unit: QuantityUnit;

    constructor(value?: number, currency?: Currency, unit?: QuantityUnit) {
        this.value = value ?? 0;
        this.currency = currency ?? null;
        this.unit = unit ?? null;
    }
}
